const DOMConditional = (props) => {
  return (
    <>
      <div style={{ display: props.show ? null : 'none' }}>
        {props.children}
      </div>
    </>
  )
}

export default DOMConditional
